export const notifications = [
  {
    id: 'ntf_001',
    title: 'Conta vencendo amanhã',
    description: 'Hostinger — R$ 89,90',
    time: 'Há 12 min',
    read: false,
    href: '/financeiro/pagar',
  },
  {
    id: 'ntf_002',
    title: 'Novo recebimento',
    description: 'Cliente XPTO — R$ 2.500,00',
    time: 'Há 1 h',
    read: false,
    href: '/financeiro/receber',
  },
  {
    id: 'ntf_003',
    title: 'NFS-e autorizada',
    description: 'Nota #000245',
    time: 'Há 3 h',
    read: false,
    href: '/fiscal/notas',
  },
  {
    id: 'ntf_005',
    title: 'NFe importada',
    description: 'XML #000088 — 3 parcelas geradas',
    time: 'Há 5 h',
    read: false,
    href: '/fiscal/notas',
  },
  {
    id: 'ntf_004',
    title: 'Relatório disponível',
    description: 'DRE gerencial — agosto/2026',
    time: 'Ontem',
    read: true,
    href: '/gestao/relatorios',
  },
];
